import {
  ContentDeciderContainer,
  Loader,
  withErrorBoundary
} from '@nile/components';
import { TicketClient } from '@nile/graphql';
import { getTabTemplate } from '@nile/mangifera/src/Pebbles/TabManager';
import envConfig from '@nile/home/src/Config/env';
import { HomeContext } from '@nile/mangifera/src/Contexts';
import { GET_PROJECTS } from '@nile/projects/src/Graphql';
import { ProjectListItem } from '@nile/projects/src/Components/Cards';
import { cloneDeep } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import sizeMe from 'react-sizeme';
import { Tag } from '@superops/ui-design-system';
import { getEmoji } from '@nile/mangifera/src/Pebbles/Views';
import { SVGIcon } from '@superops/super-icons';
import {
  WidgetWrapper,
  Header,
  Title,
  Content,
  Actions,
  Badge,
  NumberCardContainer,
  NumberTitle
} from '../HomeWidgetContainer';
import AccessDenied from './AccessDenied';
import DeletedView from './DeletedView';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

function ProjectViewWidget(props) {
  const { widget, projectViews, size, deleteWidget } = props;

  const isItProduct = useCheckIsItProduct();

  const viewPermission = widget?.permission;
  const viewExist = projectViews.some((el) => el.id === widget.id);

  const context = useContext(HomeContext);
  const [projectList, setProjectList] = useState([]);
  const [listInfo, setListInfo] = useState([]);
  const [loading, setLoading] = useState(!!widget);

  const currentView =
    viewPermission && viewExist
      ? projectViews.find((el) => el.id === widget.id)
      : widget;
  const options = { pageSize: 20, page: 1, view: { id: widget.id } };

  const navigateToView = () => {
    if (!viewPermission || !viewExist) return;
    const currentAppState = context?.userAppState || { appState: [] };
    const updatedAppState = cloneDeep(currentAppState.appState);
    const tabIdx = updatedAppState.findIndex((el) => el.id === 'workspace');
    const tab = {
      id: 'workspace',
      content: getTabTemplate({ module: 'WORKSPACE' }),
      accessibilityLabel: 'My workspace',
      module: 'WORKSPACE',
      tabId: 1,
      state: {},
      data: {},
      url: `/project/${currentView.id}/${currentView.name}`
    };
    if (tabIdx === -1) {
      updatedAppState.push(tab);
    } else {
      updatedAppState[tabIdx] = tab;
    }
    context.updateUserAppState({
      ...currentAppState,
      appState: updatedAppState,
      activeTabIndex: updatedAppState.findIndex((el) => el.id === tab.id)
    });
    context.closeHomeOverlay();
    setTimeout(() => {
      context.switchTabFocus(tab);
    }, 200);
  };
  const fetchViewData = async (personalization, pageOptions) => {
    setLoading(true);
    const response = await TicketClient.query({
      query: GET_PROJECTS,
      variables: {
        listInfo: pageOptions
          ? { ...pageOptions, view: { id: widget.id } }
          : options,
        isItProduct: !!isItProduct
      },
      fetchPolicy: 'network-only'
    });
    setProjectList(response?.data?.getProjects?.projects || []);
    setListInfo(response?.data?.getProjects?.listInfo);
    setLoading(false);
  };

  useEffect(() => {
    if (viewPermission) fetchViewData();
  }, []);

  if (loading) {
    return (
      <WidgetWrapper>
        <div className="widget-header flex center fg1">
          <Actions className="widget-actions visibilityActions">
            <div onClick={deleteWidget.bind(this, widget)} className="ptr">
              <SVGIcon name="Delete" />
            </div>
          </Actions>
        </div>
        <Loader />
      </WidgetWrapper>
    );
  }
  return (
    <WidgetWrapper>
      {size.width > 300 && size.height > 200 ? (
        <>
          <Header>
            <Title onClick={navigateToView}>
              <Badge className="mr15">{getEmoji(currentView)}</Badge>
              {currentView.name}
              {viewPermission && viewExist && (
                <div className="ml-10">
                  <Tag>
                    {projectList?.length}/{listInfo?.totalCount}
                  </Tag>
                </div>
              )}
            </Title>
            <div className="widget-header flex center fg1">
              <Actions className="widget-actions visibilityActions">
                <div onClick={deleteWidget.bind(this, widget)} className="ptr">
                  <SVGIcon name="Delete" />
                </div>
              </Actions>
            </div>
          </Header>
          {!viewPermission ? (
            <AccessDenied />
          ) : (
            <>
              {!viewExist ? (
                <DeletedView />
              ) : (
                <Content>
                  <ContentDeciderContainer
                    isLoading={loading}
                    hasContent={!loading && projectList?.length > 0}
                    mainContent={
                      <>
                        {projectList?.map((item) => (
                          <ProjectListItem
                            detail={item}
                            allowDelete={false}
                            updateList={() => {}}
                          />
                        ))}
                      </>
                    }
                    newEmptyContainer
                    loadingContent={<Loader />}
                    notFoundURL={`${envConfig.imageRoot}svg/not-found.svg`}
                  />
                </Content>
              )}
            </>
          )}
        </>
      ) : (
        <NumberCardContainer>
          <Badge className="icon">{getEmoji(currentView)}</Badge>
          <Actions className="icon visibilityActions">
            <div onClick={deleteWidget.bind(this, widget)} className="ptr">
              <SVGIcon name="Delete" />
            </div>
          </Actions>
          {!viewPermission ? (
            <AccessDenied small />
          ) : (
            <>
              {!viewExist ? (
                <DeletedView small />
              ) : (
                <div className="content ptr" onClick={navigateToView}>
                  <NumberTitle>{listInfo?.totalCount}</NumberTitle>
                  {currentView?.name}
                </div>
              )}
            </>
          )}
        </NumberCardContainer>
      )}
    </WidgetWrapper>
  );
}

export default withErrorBoundary(
  sizeMe({ monitorHeight: true })(ProjectViewWidget)
);
